import type { ColumnFiltersState } from '@tanstack/react-table';
import noop from 'lodash-es/noop';
import type { Dispatch, ReactNode, SetStateAction } from 'react';
import { createContext, useMemo } from 'react';

interface Props {
  bulkEditModalOpen: boolean;
  bulkSelectedSpecials: number[];
  children: ReactNode;
  columnFilters: ColumnFiltersState;
  setBulkSelectedSpecials: Dispatch<SetStateAction<number[]>>;
  setColumnFilters: Dispatch<SetStateAction<ColumnFiltersState>>;
}

export const GlobalSpecialsTableContext = createContext<
  Omit<Props, 'children'>
>({
  bulkEditModalOpen: false,
  bulkSelectedSpecials: [],
  columnFilters: [],
  setBulkSelectedSpecials: noop,
  setColumnFilters: noop,
});

export const GlobalSpecialsTableProvider = ({
  bulkEditModalOpen,
  bulkSelectedSpecials,
  columnFilters,
  setBulkSelectedSpecials,
  setColumnFilters,
  children,
}: Props) => {
  const contextValue = useMemo(
    () => ({
      bulkEditModalOpen,
      bulkSelectedSpecials,
      columnFilters,
      setColumnFilters,
      setBulkSelectedSpecials,
    }),
    [
      bulkEditModalOpen,
      columnFilters,
      bulkSelectedSpecials,
      setBulkSelectedSpecials,
      setColumnFilters,
    ]
  );

  return (
    <GlobalSpecialsTableContext.Provider value={contextValue}>
      {children}
    </GlobalSpecialsTableContext.Provider>
  );
};
